import TextCell from '../cells/text';

export const userBodyRender =
  // eslint-disable-next-line react/display-name
  () => (value: { full_name: string; user?: string; username?: string } | null | undefined) => {
    return (
      <>
        {' '}
        {value ? (
          <TextCell
            value={`${value.full_name} (${value.user || value.username})`}
            textAlign="left"
          />
        ) : (
          <></>
        )}
      </>
    );
  };
